module.exports = __webpack_public_path__ + "img/footer_logo.c9812ba.png";